import gql from 'graphql-tag'

const createManySpecialPrices = gql`
mutation createManySpecialPrices($newPrices: [NewSpecialPrices]!){
	cashAssist {
		createManySpecialPrices(newPrices: $newPrices) {
            id
            date
            prices
			pricesInCafe
		}
	}
}`

export default createManySpecialPrices
